import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {environment} from '../../../environments/environment';
import {catchError, from, switchMap, throwError} from 'rxjs';
import {AuthenticationService} from '../../modules/auth/services/authentication.service';

export const tokenInterceptorFn: HttpInterceptorFn = (request, next) => {
    const authenticationService = inject(AuthenticationService);

    const username = environment.baseAuthCredentials?.username || '';
    const password = environment.baseAuthCredentials?.password || '';
    const base64Credentials = btoa(`${username}:${password}`);

    const skipAuthHeader = request.headers.has('X-Skip-Auth');
    const useSecVersionHeader = request.headers.has('X-Use-Security-Auth-Version');

    if (skipAuthHeader) {
        const clonedRequest = request.clone({
            headers: request.headers.delete('X-Skip-Auth'),
            setHeaders: {
                'Authorization': `Basic ${base64Credentials}`,
            },
        });

        return next(clonedRequest);
    }

    return from(authenticationService.ensureAccessTokenIsFresh()).pipe(
        switchMap(() => {
            const accessToken = authenticationService.getAccessToken();
            const token = `Bearer ${accessToken}`;

            let clonedRequest = request;

            if (useSecVersionHeader) {
                clonedRequest = request.clone({
                    headers: request.headers.delete('X-Use-Security-Auth-Version'),
                    setHeaders: {
                        'Authorization': token,
                    },
                });
            } else {
                clonedRequest = request.clone({
                    setHeaders: {
                        'Authorization': `Basic ${base64Credentials}`,
                        'X-Auth-Token': token,
                    },
                });
            }

            return next(clonedRequest);
        }),
        catchError((error) => {
            console.error('Error in token interceptor:', error);
            return throwError(() => error);
        })
    );
};
